import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./assest_design/ProCRM.css";

import CRMNavbar from "./components/crm/CRMNavbar";
import CRMDashboard from "./components/crm/CRMDashboard";
import LeadTracker from "./components/crm/LeadTracker";
import AddLead from "./components/crm/AddLead";
import OutreachLibrary from "./components/crm/OutreachLibrary";
import CampaignBuilder from "./components/crm/CampaignBuilder";
import AgentGuide from "./components/crm/AgentGuide";
import Playbooks from "./components/crm/Playbooks";
import Reports from "./components/crm/Reports";

import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { db } from "./firebase";

function ProCRM() {
  const [activeView, setActiveView] = useState("dashboard");
  const [leads, setLeads] = useState([]);
  const [loadingLeads, setLoadingLeads] = useState(true);
  const [leadsError, setLeadsError] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    setLoadingLeads(true);
    setLeadsError("");

    const leadsQuery = query(
      collection(db, "leads"),
      orderBy("createdAt", "desc")
    );

    const unsubscribe = onSnapshot(
      leadsQuery,
      (snapshot) => {
        const firestoreLeads = snapshot.docs.map((leadDoc) => ({
          id: leadDoc.id,
          ...leadDoc.data(),
        }));

        setLeads(firestoreLeads);
        setLoadingLeads(false);
      },
      (error) => {
        console.error("Error loading leads:", error);
        setLeadsError(
          "Could not load leads from Firestore. Please check your Firebase rules and database setup."
        );
        setLoadingLeads(false);
      }
    );

    return () => unsubscribe();
  }, []);

  const handleLogout = () => {
    navigate("/home");
  };

  return (
    <div className="procrm-shell">
      <CRMNavbar
        activeView={activeView}
        setActiveView={setActiveView}
        handleLogout={handleLogout}
      />

      <main className="procrm-page">
        {leadsError && (
          <section className="procrm-panel crm-section crm-error-panel">
            <strong>Firestore Error</strong>
            <p>{leadsError}</p>
          </section>
        )}

        {loadingLeads && (
          <section className="procrm-panel crm-section crm-loading-panel">
            <img src="/linkhighlight.png" alt="ProCode ZA" />
            <div>
              <strong>Loading CRM leads...</strong>
              <p>Fetching your live lead data from Firestore.</p>
            </div>
          </section>
        )}

        {!loadingLeads && activeView === "dashboard" && (
          <CRMDashboard leads={leads} setActiveView={setActiveView} />
        )}

        {!loadingLeads && activeView === "leads" && (
          <LeadTracker leads={leads} setLeads={setLeads} />
        )}

        {!loadingLeads && activeView === "addLead" && (
          <AddLead setLeads={setLeads} setActiveView={setActiveView} />
        )}

        {!loadingLeads && activeView === "outreach" && <OutreachLibrary />}

        {!loadingLeads && activeView === "campaignBuilder" && (
          <CampaignBuilder />
        )}

        {!loadingLeads && activeView === "agentGuide" && <AgentGuide />}

        {!loadingLeads && activeView === "playbooks" && <Playbooks />}

        {!loadingLeads && activeView === "reports" && (
          <Reports leads={leads} />
        )}
      </main>
    </div>
  );
}

export default ProCRM;